module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/demos/home-event-c093fd6f513594cb675116f924c09cd9.png";